import { api } from './api';

export interface Slot { day: string; periodNumber: number; subjectId: string; teacherId: string | null; roomId: string | null; }
export interface Grid { id: string; academicClassId: string; slots: Slot[]; }
export interface Clash { kind: string; day: string; periodNumber: number; message: string; }
export interface SetCellResult { placed: boolean; clashes: Clash[]; grid: Grid; }
export interface Room { id: string; name: string; capacity: number | null; isActive: boolean; }
export interface TeacherLoad { teacherId: string; maxPeriodsPerWeek: number; }
export interface SubjectDemand { subjectId: string; teacherId?: string | null; roomId?: string | null; periodsPerWeek: number; }
export interface AutoGenResult { complete: boolean; placed: number; unplaced: number; skipped: Clash[]; grid: Grid; }

export const timetableApi = {
  grid: (classId: string) => api.get<Grid>(`/api/timetable/classes/${classId}/grid`),
  setCell: (b: { academicClassId: string; day: string; periodNumber: number; subjectId: string | null; teacherId?: string | null; roomId?: string | null }) =>
    api.post<SetCellResult>('/api/timetable/set-cell', b),
  autoGenerate: (b: { academicClassId: string; demands: SubjectDemand[]; overwrite: boolean }) =>
    api.post<AutoGenResult>('/api/timetable/auto-generate', b),
  listRooms: () => api.get<Room[]>('/api/timetable/rooms'),
  createRoom: (b: { institutionId: string; name: string; capacity?: number | null }) =>
    api.post<Room>('/api/timetable/rooms', b),
  listTeachers: () => api.get<{ id: string; displayName: string }[]>('/api/timetable/teachers'),
  listLoads: () => api.get<TeacherLoad[]>('/api/timetable/teacher-loads'),
  setLoad: (b: { teacherId: string; maxPeriodsPerWeek: number }) =>
    api.put<TeacherLoad>('/api/timetable/teacher-loads', b),
};
